module.exports = __webpack_public_path__ + "img/solution2_chart1.bd55ff2d.png";